import React, { useEffect, useState } from "react";
import { SOCKET_CLIENT } from "../../../../utils/socket";
import { ChatRoomDetails } from "../../services/chat.services"; // Should accept roomID and return { senderId, receiverId }

const LiveConsultationMonitor = () => {
  const [roomIDs, setRoomIDs] = useState([]);
  const [roomDetails, setRoomDetails] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleActiveRoomsUpdate = (ids) => {
      console.log("Received ACTIVE-ROOMS-UPDATE:", ids);
      setRoomIDs(ids);
    };

    const handleActiveRooms = (ids) => {
      console.log("Received ACTIVE-ROOMS (initial):", ids);
      setRoomIDs(ids);
    };

    const handleSessionExited = (roomID) => {
      console.log("Received SESSION-EXITED:", roomID);
      setRoomIDs((prev) => prev.filter((id) => id !== roomID));
    };

    SOCKET_CLIENT.on("ACTIVE-ROOMS-UPDATE", handleActiveRoomsUpdate);
    SOCKET_CLIENT.on("SESSION-EXITED", handleSessionExited);
    SOCKET_CLIENT.emit("GET-ACTIVE-ROOMS");
    SOCKET_CLIENT.on("ACTIVE-ROOMS", handleActiveRooms);

    return () => {
      console.log("Cleaning up LiveConsultationMonitor listeners");
      SOCKET_CLIENT.off("ACTIVE-ROOMS-UPDATE", handleActiveRoomsUpdate);
      SOCKET_CLIENT.off("SESSION-EXITED", handleSessionExited);
      SOCKET_CLIENT.off("ACTIVE-ROOMS", handleActiveRooms);
    };
  }, []);

  useEffect(() => {
    const missingIDs = roomIDs.filter((id) => !roomDetails[id]);
    const removedIDs = Object.keys(roomDetails).filter(
      (id) => !roomIDs.includes(id),
    );

    if (missingIDs.length === 0 && removedIDs.length === 0) return;

    // Clean up removed rooms from state
    if (removedIDs.length > 0) {
      setRoomDetails((prev) => {
        const next = { ...prev };
        removedIDs.forEach((id) => delete next[id]);
        return next;
      });
    }

    if (missingIDs.length === 0) return;

    setLoading(true);
    Promise.all(
      missingIDs.map((id) =>
        ChatRoomDetails(id)
          .then((res) => ({ id, ...res.data }))
          .catch(() => null),
      ),
    )
      .then((results) => {
        setRoomDetails((prev) => {
          const next = { ...prev };
          results.forEach((r) => {
            if (
              r &&
              r.senderId &&
              r.receiverId &&
              r.senderId._id &&
              r.receiverId._id
            ) {
              next[r.id] = r;
            }
          });
          return next;
        });
      })
      .finally(() => setLoading(false));
  }, [roomIDs]);

  // Filter only valid room IDs for rendering cards
  const validRoomIDs = roomIDs.filter(
    (roomID) =>
      roomDetails[roomID] &&
      roomDetails[roomID].senderId &&
      roomDetails[roomID].receiverId &&
      roomDetails[roomID].senderId._id &&
      roomDetails[roomID].receiverId._id, // Check userID or _id
  );

  return (
    <div className="bg-gray-100 p-8 rounded-xl">
      <h2 className="text-2xl font-bold mb-6">Ongoing Live Consultations</h2>
      {loading ? (
        <p className="text-center">Loading meetings...</p>
      ) : validRoomIDs.length === 0 ? (
        <p className="text-center text-gray-500">No active meetings.</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {validRoomIDs.map((roomID) => {
            const details = roomDetails[roomID];
            return (
              <div
                key={roomID}
                className="bg-white shadow rounded-lg p-5 flex items-center"
              >
                <div className="flex-1">
                  <div className="flex items-center mb-2">
                    <img
                      src={details.senderId.profile_image}
                      alt={details.senderId.name}
                      className="w-12 h-12 rounded-full mr-4 border"
                    />
                    <span className="font-semibold text-lg">
                      {details.senderId.name}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <img
                      src={details.receiverId.profile_image}
                      alt={details.receiverId.name}
                      className="w-12 h-12 rounded-full mr-4 border"
                    />
                    <span className="font-semibold text-lg text-purple-700">
                      {details.receiverId.name}
                    </span>
                  </div>
                </div>
                {/* Optionally, show Room ID or other info */}
                {/* <div className="ml-6">
                                    <span className="bg-purple-100 text-purple-800 text-xs font-semibold px-4 py-1 rounded">Room: {roomID}</span>
                                </div> */}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LiveConsultationMonitor;
